import request from '@/utils/request'

// 创建课程订单
// POST /api/frontend/order/create
// 参数: {
//   "cashAmount": 0,      // 现金支付金额
//   "coinAmount": 0,      // 积分支付金额
//   "couponAmount": 0,    // 优惠券支付金额
//   "couponId": 0,        // 优惠券ID
//   "courseId": 0,        // 课程ID
//   "payType": 0          // 支付方式
// }
// 返回: {
//   "code": 0,
//   "data": {
//     "orderId": 0,        // 订单ID
//     "payAmount": 0,      // 支付金额
//     "payUrl": ""         // 支付链接
//   },
//   "message": ""
// }
export function createCourseOrder(data) {
  return request({
    url: '/api/frontend/order/create',
    method: 'post',
    data
  })
}

export function createPaperOrder(data) {
  return request({
    url: '/api/frontend/paper/order/create',
    method: 'post',
    data
  })
}

export function createClassOrder(data) {
  return request({
    url: '/api/frontend/order/create',
    method: 'post',
    data
  })
}

export function alipayCallback(data) {
  return request({
    url: '/api/frontend/payment/callback/alipay',
    method: 'post',
    data
  })
}

export function wechatCallback(data) {
  return request({
    url: '/api/frontend/payment/callback/wechat',
    method: 'post',
    data
  })
}

export function payOrder(params) {
  return request({
    url: '/api/frontend/payment/pay',
    method: 'post',
    params
  })
}

export function getMyOrders(params) {
  return request({
    url: '/api/frontend/personal/my-orders',
    method: 'get',
    params
  })
}

export function getOrderDetail(id) {
  return request({
    url: '/api/frontend/order/detail',
    method: 'get',
    params: { id }
  })
}

export function getOrderPaymentStatus(orderNo, config) {
  return request({
    url: '/api/frontend/personal/order-payment-status',
    method: 'get',
    params: { orderNo },
    ...(config || {})
  })
}

// 支付方式类型定义
// 0: 微信支付
// 1: 支付宝支付
// 2: 余额支付
// 3: 积分支付
// 4: 优惠券支付
// 5: 组合支付

// 使用示例:
// createCourseOrder({
//   courseId: 123,
//   payType: 0, // 微信支付
//   cashAmount: 100,
//   coinAmount: 0,
//   couponAmount: 0,
//   couponId: 0
// })

// 组合支付示例:
// createCourseOrder({
//   courseId: 123,
//   payType: 5, // 组合支付
//   cashAmount: 50,
//   coinAmount: 30,
//   couponAmount: 20,
//   couponId: 456
// })

// 删除商城订单
export function deleteMallOrder(id, orderCategory) {
  return request({
    url: `/api/frontend/personal/mall/order/${id}`,
    method: 'delete',
    params: orderCategory ? { orderCategory } : undefined
  })
}

// 隐藏订单（用户软删除，仅前端不展示）
export function hideOrder(id, orderCategory) {
  return request({
    url: `/api/frontend/personal/order/${id}/hide`,
    method: 'put',
    params: { orderCategory }
  })
}
